import { render, staticRenderFns } from "./RequiredOption.vue?vue&type=template&id=22a6f0fd&"
import script from "./RequiredOption.vue?vue&type=script&lang=ts&"
export * from "./RequiredOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports